/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Range_1_YearInputs */

const en_dashboard_range_1_year = /** @type {(inputs: Dashboard_Range_1_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last year`)
};

const pt_br2_dashboard_range_1_year = /** @type {(inputs: Dashboard_Range_1_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último ano`)
};

/**
* | output |
* | --- |
* | "Last year" |
*
* @param {Dashboard_Range_1_YearInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_range_1_year = /** @type {((inputs?: Dashboard_Range_1_YearInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Range_1_YearInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_range_1_year(inputs)
	return pt_br2_dashboard_range_1_year(inputs)
});